/**    
<summary>
  This functional component "DeviceAccessPopupHOC" provides props to the child component.
  1. State "showDeviceAccessPopup" that manages the show/hide of pop up
  2. Function "deviceAccessToggleHandler" to toggle the show/hide popup state "showDeviceAccessPopup"
  @developer Chandan Singh
  @created Date:05-May-2026,10:00 PM
</summary>
<returns>Returns JSX</returns>
**/
import React, { useState } from "react";

const DeviceAccessPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showDeviceAccessPopup, setShowDeviceAccessPopup] =
      useState<boolean>(false);

    const deviceAccessToggleHandler = () => {
      setShowDeviceAccessPopup(!showDeviceAccessPopup);
    };

    return (
      <Component
        showDeviceAccessPopup={showDeviceAccessPopup}
        deviceAccessToggleHandler={deviceAccessToggleHandler}
        {...props}
      />
    );
  };

export default DeviceAccessPopupHOC;
